import { createContext, useContext } from 'react';

/** The key of the tab whose panel is drawn. SettingsTabs provides it around its panel. */
export const SettingsTabKeyContext = createContext<string | null>(null);

/**
 * The `?tab=` key of the settings tab this card is drawn in, or null outside SettingsTabs.
 *
 * For a card that rewrites the query itself: it puts the tab in that same write
 * (`next.set(TAB_PARAM, key)`), so the selected tab stays in `?tab=`. The Canva card clears `?canva=`
 * once it has reported the return from Canva, and that parameter is what opened its tab (SettingsTabs'
 * `initialTab`): without `?tab=` in the same write, a reload or a copied link would open the first tab
 * instead. In the same write, not a second one from SettingsTabs: two navigations made at once undo
 * each other, as each starts from the query its own component last drew.
 */
export function useSettingsTabKey(): string | null {
  return useContext(SettingsTabKeyContext);
}
